import {
  accountIdFormat,
  locationIdFormat,
  taskIdFormat,
} from "@redotech/redo-ids-cockroach";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum TaskDomain {
  WAREHOUSE = "warehouse",
  RETURNS = "returns",
}

export const TaskDomainSchema = createEnum(TaskDomain);

export enum TaskSubtype {
  REPLENISHMENT = "replenishment",
  COUNT = "count",
  UNDECLARED_ITEM = "undeclared_item",
  UNFULFILLABLE_ITEM = "unfulfillable_item",
}

export const TaskSubtypeSchema = createEnum(TaskSubtype);

export enum TaskStatus {
  OPEN = "open",
  CLAIMED = "claimed",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export const TaskStatusSchema = createEnum(TaskStatus);

export enum TaskPriority {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
  URGENT = "urgent",
}

export const TaskPrioritySchema = createEnum(TaskPriority);

export enum UndeclaredItemAction {
  DISPOSE = "dispose",
  SEND_BACK_TO_CUSTOMER = "send_back_to_customer",
  PROCESS_ACCORDING_TO_SERVICE_AGREEMENT = "process_according_to_service_agreement",
}

export const UndeclaredItemActionSchema = createEnum(UndeclaredItemAction);

export const TaskReferenceSchema = z.object({
  referenceTable: z.string(),
  referenceId: z.string(),
});
export interface TaskReference extends z.infer<typeof TaskReferenceSchema> {}

const TaskSchema_ = z.object({
  id: taskIdFormat.schema,
  accountId: accountIdFormat.schema,
  locationId: locationIdFormat.schema.nullable(),
  name: z.string().nullable(),
  domain: TaskDomainSchema,
  subtype: TaskSubtypeSchema,
  status: TaskStatusSchema,
  priority: TaskPrioritySchema,
  /** @deprecated Use references instead */
  referenceType: z.string(),
  /** @deprecated Use references instead */
  referenceId: z.string(),
  references: z.array(TaskReferenceSchema),
  createdByLegacyUserId: z.string().nullable(),
  claimedByLegacyUserId: z.string().nullable(),
  completedByLegacyUserId: z.string().nullable(),
  dueAt: z.date().nullable(),
  claimedAt: z.date().nullable(),
  completedAt: z.date().nullable(),
  cancelledAt: z.date().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const TaskSchema: z.ZodType<Task> = TaskSchema_;
export interface Task extends z.infer<typeof TaskSchema_> {}
